export default __webpack_public_path__ + "static/3_15-1--ec0f7e98798db7e46f95c1963a2097c3.png";